<template>
  <div class="app-bar-component">
    <div
      class="mobile-menu-section d-flex j-between a-center"
      :style="{ opacity: showMobileMenu ? 1 : 0 }"
    >
      <!-- кнопка меню чёрная с белой иконкой - отличается от кнопки показателей -->
      <v-btn
        class="button-menu button-menu--aside ml-2 pa-0"
        color="#333333"
        icon
        elevation="2"
        @click="toggleAside"
      >
        <font-awesome-icon size="2x" icon="bars" />
      </v-btn>

      <global-filial-select
        class="bar-select bar-select-mobile select-filials"
      />

      <!-- показатели: три точки, при открытых - крестик -->
      <v-btn
        class="button-menu button-menu--metrics mr-2 pa-0"
        color="#f1f3f6"
        icon
        @click="toggleHeader"
      >
        <font-awesome-icon v-if="!showHeader" size="2x" icon="ellipsis-v" />
        <font-awesome-icon v-if="showHeader" size="2x" icon="times" />
      </v-btn>
      <profile-avatar mobile />
    </div>

    <div v-show="showHeader" class="mobile-wrapper"></div>
    <v-app-bar
      v-show="showHeader"
      id="default-app-bar"
      app
      absolute
      class="v-bar--underline"
      color="transparent"
      :clipped-left="$vuetify.rtl"
      :clipped-right="!$vuetify.rtl"
      height="87"
      flat
    >
      <div class="left-app-bart-part d-flex align-center">
        <div v-if="showMobileMenu" class="d-flex align-center mb-3">
          <notification-button />
          <global-filial-select class="bar-select select-filials" />
        </div>
        <template v-else>
          <notification-button />
          <global-filial-select class="bar-select select-filials" />
        </template>

        <div
          v-outside="closeDatepicker"
          class="datepicker-section"
          :class="{ hidden: !isDatepickerHidden }"
        >
          <v-btn
            :disabled="!isDatepickerHidden"
            class="bar-button button-datepicker bar-button--history text-normalize"
            height="60"
            depressed
            @click="showDatepicker = !showDatepicker"
          >
            <font-awesome-icon color="#FF9100" icon="calendar-alt" />
            <span class="d-flex font-weight-light flex-column text-left">
              Заказы за
              <span class="font-weight-medium">{{
                formattedSelectedDate
              }}</span>
            </span>
          </v-btn>
          <div class="datepicker">
            <v-date-picker
              v-show="showDatepicker && isDatepickerHidden"
              v-model="orderDate"
              :first-day-of-week="1"
              elevation="1"
              no-title
              locale="ru"
            />
          </div>
        </div>

        <!--      <v-btn depressed class="bar-button button-calls text-normalize" height="60">
          <font-awesome-icon color="#FF9100" icon="phone-alt" />
          Звонки
        </v-btn>-->

        <search-input :disabled="hideSearchInput" :mobile="showMobileMenu" />

        <div v-if="hideSearchInput" class="search-field-span"></div>
      </div>
      <div class="right-app-bart-part d-flex align-center">
        <filial-metrics />

        <!--      <v-sheet
          class="bar-sheet sheet-orders-count d-flex a-center flex-shrink-0"
          height="60"
          width="auto"
        >
          <div class="d-flex flex-column">
            <span class="d-block count">{{ getOrdersCount }}</span>
            <span>выполнено</span>
          </div>
        </v-sheet>

        <v-sheet
          class="bar-sheet sheet-total d-flex a-center flex-shrink-0"
          height="60px"
          min-width="133px"
          width="auto"
        >
          <div class="d-flex flex-column">
            <span class="d-block count"> {{ getTotalProceed }} </span>
            <span>выручка за день</span>
          </div>
        </v-sheet>-->

        <profile-avatar />
      </div>
    </v-app-bar>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Vue from 'vue'
  import outside from '@/directives/outside'
  import moment from 'moment'
  import GlobalFilialSelect from '@/components/header/GlobalFilialSelect'
  import FilialMetrics from '@/components/header/FilialMetrics'
  import NotificationButton from '@/components/notifications/NotificationButton.vue'
  import { getCurrency } from '@/util/money'
  import ProfileAvatar from '@/components/header/ProfileAvatar.vue'
  import SearchInput from '@/components/header/SearchInput.vue'

  Vue.use(outside)

  export default {
    name: 'Header',
    components: {
      ProfileAvatar,
      FilialMetrics,
      GlobalFilialSelect,
      NotificationButton,
      SearchInput,
    },

    data () {
      return {
        showHeader: false,
        isOrdersPage: false,
        isDatepickerHidden: true,
        showDatepicker: false,
        adminInfoTimeout: null,
        searchTimeout: null,
        showMobileMenu: false,
      }
    },
    computed: {
      ...mapGetters({
        filters: 'orders/getOrderFilters',
        localStorageBranch: 'branches/getLocalStorageBranch',
        isCallCenter: 'branches/getGlobalFilialIsCallCenter',
      }),
      ...mapState({
        ordersFilterDate: (state) => state.orders.ordersFilterDate,
        adminInfo: (state) => state.admin.adminInfo,
        user: (state) => state.auth.user || {},
        userFilials: (state) => state.auth.userFilials,
        showMainAside: (state) => state.app.showMainAside,
      }),
      hideSearchInput () {
        // На странице заказов колл-центра работает полноширинный поиск в самой странице.
        return this.isOrdersPage && this.isCallCenter
      },
      orderDate: {
        get () {
          return this.ordersFilterDate
        },
        set (value) {
          this.$store.commit('orders/setFilterDate', value)
          this.storeSelectedDateToLocalStorage(value)
        },
      },
      formattedSelectedDate () {
        return moment(this.orderDate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      },
      getOrdersCount () {
        return this.adminInfo.totalOrder !== undefined
          ? this.$options.filters.currency(this.adminInfo.totalOrder)
          : '---'
      },
      getTotalProceed () {
        return this.adminInfo.totalProceed !== undefined
          ? this.$options.filters.currency(this.adminInfo.totalProceed) +
            getCurrency()
          : '---'
      },
      selectedBranch: {
        get () {
          return this.localStorageBranch
        },
        set (value) {
          if (value.id !== this.selectedBranch.id) {
            this.$store.commit('branches/setCurrentBranch', value)
            window.location.reload()
          }
        },
      },
    },
    watch: {
      $route () {
        this.showDatepicker = false
        this.checkOrdersPage()
      },
      ordersFilterDate (newDate) {
        this.$store.dispatch('admin/fetchAdminShortInfo', {
          date: newDate,
          clear: true,
        })
        this.$store.dispatch('reviews/fetchFinalRating')
      },
    },
    created () {
      window.addEventListener('resize', this.checkWindowWidth)
      this.checkWindowWidth()
      /* this.getAdminInfo()
    clearInterval(this.adminInfoTimeout)
    this.adminInfoTimeout = setInterval(() => {
      this.getAdminInfo()
    }, 60000) */
      this.checkOrdersPage()
      this.initDatepickerValue()
      this.checkDatepickerVisibility()
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.checkWindowWidth)
      clearInterval(this.adminInfoTimeout)
      clearInterval(this.searchTimeout)
    },
    methods: {
      toggleHeader () {
        this.showHeader = !this.showHeader
      },
      toggleAside () {
        this.$store.commit('app/toggleAside', !this.showMainAside)
      },
      checkWindowWidth () {
        this.showHeader = window.innerWidth > 1024
        this.showMobileMenu = !this.showHeader
      },
      getAdminInfo (date) {
        this.$store.dispatch('admin/fetchAdminShortInfo', { date })
      },
      checkOrdersPage () {
        this.isOrdersPage = this.$router.currentRoute.path === '/orders'
      },
      checkDatepickerVisibility () {
      // this.isOrdersPage = this.$router.currentRoute.path === '/orders'
      // this.isDatepickerHidden = (['/orders', '/administrator/cashier']).includes(this.$router.currentRoute.path)
      },
      closeDatepicker () {
        this.showDatepicker = false
      },
      initDatepickerValue () {
        try {
          const savedDate = localStorage.getItem('selectedDate')
          if (savedDate) {
            this.$store.commit('orders/setFilterDate', savedDate)
          }
        } catch (e) {
          console.log(e)
        }
      },
      storeSelectedDateToLocalStorage (value) {
        if (value === moment().format('Y-MM-DD')) {
          localStorage.removeItem('selectedDate')
        } else {
          localStorage.setItem('selectedDate', value)
        }
      },
    },
  }
</script>

<!--suppress LessResolvedByNameOnly -->
<style lang="less" scoped>
.app-bar-component {
  .hidden {
    display: none;
    opacity: 0;
  }

  .v-input {
    font-size: 14px;
  }
  .mobile-wrapper {
    display: none;
  }
  .v-bar--underline {
    ::v-deep {
      .v-toolbar__content {
        display: flex;
        align-items: center;
        justify-content: stretch;
        width: 100%;
        max-width: 100%;
      }
    }
  }

  .left-app-bart-part {
    flex-grow: 1;
    // Левая часть сжимается вместе с шапкой на любой ширине - иначе выбор
    // филиала держит свои 200px (min-content) и выталкивает правую часть за
    // край экрана. Без этого на 1401-1466px, где сайдбар уже раскрыт до
    // 260px, шапка вылезала до 48px. Сжимается сам выбор филиала, до min-width
    min-width: 0;

    .select-filials {
      .media-sm({
        display: none;
      });
    }
  }

  .bar-button {
    height: 50px;
    font-size: 14px;
    background-color: @color-secondary !important;
    margin-right: 10px;
    border-radius: 5px;

    svg {
      margin-right: 15px;
    }

    &--history {
      padding: 0 15px 0 10px;
    }

    // компактный десктоп: промежутки между блоками шапки 6px вместо 10px
    .media-compact-pc({
      margin-right: 6px;
    });

    .media-xl({
      //margin-right: 20px;

      &--history {
        padding: 0 30px 0 25px;
      }
    });
  }

  .bar-select {
    height: 60px;
    margin-right: 10px;
    max-width: 215px;
    border-radius: 5px;

    svg {
      margin-right: 12px;
    }

    &.select-filials {
      max-width: 350px;
      min-width: 240px;
      .media-xl({
        max-width: 300px;
      });
      // До 1500px: при длинных значениях метрик выбор филиала отдаёт место
      // и обрезает название, но шапка не вылезает за экран. 110px, а не 150:
      // на 1401-1416px с раскрытым сайдбаром и скроллбаром Windows
      // при 150px кнопка поиска заезжала под первую метрику
      @media (max-width: 1500px) {
        max-width: 200px;
        min-width: 110px;
      }
      // кнопка с иконкой, см. GlobalFilialSelect
      .media-compact-pc-narrow({
        max-width: 60px;
        min-width: 60px;
      });
    }

    .media-compact-pc({
      margin-right: 6px;
    });

    .media-xl({
      //margin-right: 20px;
    });
  }

  .search-field-span {
    margin-right: 56px;
    flex: 1;
  }

  .bar-sheet {
    background-color: @color-secondary;
    padding: 12px;
    border-radius: 5px;
    margin-right: 10px;

    span {
      font-size: 11px;
      line-height: 1;
    }

    .count {
      font-size: 24px;
      line-height: 29px;
    }

    &.sheet-svo,
    &.sheet-cto {
      &:not(.sheet-svo-last) {
        margin-right: 10px;
      }
      .count {
        font-size: 15px;
        color: #6bad00;
        font-weight: bold;
        white-space: nowrap;
      }
      span {
        white-space: nowrap;
      }
      &.svo-bad {
        .count {
          color: #e91e63;
        }
      }
      .media-sm({
        justify-content: center;

        &.sheet-svo-last {
          margin-right: 0;
        }

        .count {
          font-size: 24px;
        }
        span {
          text-align: center;
        }
      });
    }

    .media-xl({
      margin-right: 10px;
    });
  }
  .indicators-row {
    flex-grow: 0;
    flex-wrap: nowrap;
    .media-sm({
      margin-bottom: 10px;
      margin-right: 5px;
    });
  }
  .datepicker-section {
    position: relative;
    z-index: 1;
    .datepicker {
      position: absolute;
      left: 0;
      top: 100%;
      z-index: 1;
    }
  }
  .button-menu {
    display: none;
  }

  .mobile-menu-section {
    display: flex;
    //opacity: 0;

    .menu-avatar {
      display: none;
    }
  }

  .button-notifications {
    svg {
      margin-right: 0;
    }
    span {
      margin-left: 15px;
    }

    @media (max-width: 1903px) {
      min-width: 60px;
      svg {
        margin-right: 0;
      }
    }
  }

  .media-md({
    .v-bar--underline {
      ::v-deep {
        .v-toolbar__content {
          padding: 20px 5px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: flex-start;
          height: 100% !important;
          overflow-y: auto;
        }
      }
    }
  });

  .media-sm({
    .v-bar--underline {
      ::v-deep {
        .v-toolbar__content {
          padding-top: 40px !important;
          }
        }
      }
  });

  .media-lg({
    font-size: 14px;
    position: relative;
    z-index: 1;
    .v-bar--underline {
      position: absolute;
      top: 60px;
      overflow: hidden;
      height: calc(100vh - 60px) !important;
      ::v-deep {
        .v-toolbar__content {
          padding: 20px 5px;
          display: block;
          flex-wrap: wrap;
          align-items: flex-start;
          justify-content: flex-start;
          height: 100% !important;
          overflow-y: auto;
        }
      }
    }
    .mobile-wrapper {
      display: block;
      position: fixed;
      left: 0;
      top: 75px;
      width: 100%;
      height: calc(100vh - 60px);
      background-color: #fafafa;
      z-index: 1;
    }
    .button-menu {
      display: block;
      margin-top: 0;
      .fill-svg(#333333);

      &--aside {
        background-color: #333333 !important;
        .fill-svg(#ffffff);
      }

      // квадрат в высоту выбора филиала, с его же фоном и мягкой тенью
      &--metrics {
        width: 60px !important;
        height: 60px !important;
        border-radius: 10px !important;
        background-color: @color-secondary !important;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
      }
    }
    .select-filials {
      margin-right: 0;
      font-size: 14px;
      max-width: 100%;
      //display: none;
    }
    .datepicker-section {
      width: 100%;
      margin-bottom: 10px;
    }
    .button-datepicker {
      margin-right: 5px;
      width: 100%;
    }
    .button-calls {
      display: none;
      margin-bottom: 10px;
      width: 100%;
    }
    .text-field-search {
      display: none;
      margin-right: 0;
      width: 100%;
      margin-bottom: 10px;
    }
    .sheet-orders-count {
      margin-right: 5px;
      margin-bottom: 10px;
    }
    .sheet-total {
      margin-right: 5px;
      margin-bottom: 10px;
    }

    .mobile-menu-section {
      display: flex;
      padding-top: 12px;

      .menu-avatar {
        display: block;
        width: 20px;
      }

      .bar-select-mobile {
        margin: 0 10px 0 10px;
        height: auto;
        border-radius: 10px;

        // фон рисует слот Vuetify (solo), у него своё скругление 4px
        ::v-deep .v-input__slot {
          border-radius: 10px;
        }
      }
    }
  });

  .media-sm({
    .mobile-menu-section {
      gap: 4px;

      .bar-select-mobile {
        flex: 1 1 auto;
        min-width: 0;
        max-width: calc(100vw - 150px); // гамбургер + аватар + «ещё» + отступы

        .v-select__selection {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .button-menu {
        flex: 0 0 auto;
      }
    }

    .datepicker-section .datepicker {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 210;
      max-width: calc(100vw - 24px);

      .v-picker {
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
      }
    }
  });
}
</style>
